import { Button, styled } from '@mui/material';

// Primary action button for the Collab Club admin (Log manually / Connect).
// Reuses the app's purple palette (matches PurpleButton) for default / hover /
// focus, but leaves size and spacing to each call site.
const PrimaryButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.colors.main.purple,
  color: theme.colors.main.white,
  fontFamily: 'inherit',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: theme.colors.main.purpleDark,
  },
  '&.Mui-focusVisible': {
    backgroundColor: theme.colors.main.purpleDark,
  },
  '&.Mui-disabled': {
    backgroundColor: 'rgba(0,0,0,0.12)',
    color: 'rgba(0,0,0,0.26)',
  },
})) as typeof Button;

export default PrimaryButton;
